import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DOMAIN_ENVIRONMENT } from 'src/app/_services/base.service';
import { PlatformService } from 'src/app/_services/platform.service';
import { UsuarioService } from 'src/app/_services/usuario.service';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { SubiendoOportunidadesComponent } from 'src/app/_shared/bloque-loading/subiendo-oportunidades/subiendo-oportunidades.component';
import { MinifichaAudiovisual } from 'src/app/creative/public/_models/minificha-audiovisual';
import { FichaOpAbiertaAudiovisualComponent } from 'src/app/creative/public/audiovisual/oportunidades-audiovisual/ficha-op-abierta-audiovisual/ficha-op-abierta-audiovisual.component';
import { ProyectosHomeService } from 'src/app/home/_services/proyectos-home.service';

@Component({
  selector: 'app-home-creative',
  standalone: true,
  imports: [
    SharedModule,
    RouterModule,
    FichaOpAbiertaAudiovisualComponent,
    SubiendoOportunidadesComponent,
  ],
  templateUrl: './home-creative.component.html',
  styleUrls: ['./home-creative.component.scss']
})
export class HomeCreativeComponent implements OnInit
{
  platformId: string;
  domainUrl: string;
  isLoading: boolean = false;
  oportunidadCreative: MinifichaAudiovisual;
  oportunidadId: number;

  constructor(
    private _usuarioService: UsuarioService,
    private _platformService: PlatformService,
    private _proyectosHomeService: ProyectosHomeService,
  ) { }

  ngOnInit(): void
  {
    this.platformId = DOMAIN_ENVIRONMENT[this._platformService._domainEnvironment];
    this.domainUrl = this._platformService.getSubdominioUrl('creative');
    this.getOportunidadId();
  }

  getOportunidadId(): void
  {
    this.isLoading = true;

    this._proyectosHomeService.getProyectosHome('audiovisual').subscribe({
      next: (r) =>
      {
        this.isLoading = false;
        this.oportunidadId = r.proyectoId;
      },
      complete: () =>
      {
        this.oportunidadId > 0 && this.getOportunidadHome();
      },
      error: (e) =>
      {
        this.isLoading = false;
      }
    });
  }
  getOportunidadHome(): void
  {
    this.isLoading = true;
    this._proyectosHomeService.getProyectoAudiovisual(this.oportunidadId).subscribe({
      next: (r) =>
      {
        this.isLoading = false;
        this.oportunidadCreative = r;
      },
      error: (e) =>
      {
        this.isLoading = false;
      }
    });
  }

}
